"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var swiper_1 = require("swiper");
var modules_1 = require("swiper/modules");
document.addEventListener('alpine:init', function () {
    Alpine.data('newsCarousel', function () {
        return {
            flyoutOpen: false,
            flyoutLoading: false,
            flyoutError: false,
            flyoutTitle: '',
            flyoutHeader: '',
            flyoutContent: '',
            flyoutUrl: '',
            previouslyFocused: null,
            cache: {},
            init: function () {
                this.initCarousel();
            },
            initCarousel: function () {
                var _this = this;
                new swiper_1.default(this.$refs.carousel, {
                    modules: [modules_1.A11y, modules_1.Navigation, modules_1.Pagination, modules_1.Mousewheel],
                    loop: false,
                    grabCursor: true,
                    speed: 500,
                    spaceBetween: 32,
                    slidesPerView: 1.15,
                    breakpoints: {
                        640: {
                            slidesPerView: 2.15,
                        },
                        1024: {
                            slidesPerView: 3,
                        },
                    },
                    mousewheel: {
                        forceToAxis: true,
                        releaseOnEdges: true,
                    },
                    navigation: {
                        prevEl: this.$refs.prev,
                        nextEl: this.$refs.next,
                    },
                    pagination: {
                        el: this.$refs.pagination,
                        clickable: true,
                        bulletClass: 'block size-3 rounded-full bg-terracotta/20 cursor-pointer transition-all duration-500',
                        bulletActiveClass: '!bg-terracotta !size-4 outline outline-2 outline-offset-2 outline-terracotta',
                        renderBullet: function (index, className) {
                            return "<button type=\"button\" class=\"".concat(className, "\" aria-label=\"Go to slide ").concat(index + 1, "\"></button>");
                        },
                    },
                    on: {
                        slideChange: function (swiper) {
                            var liveRegion = _this.$refs.liveRegion;
                            if (liveRegion) {
                                liveRegion.textContent = "Slide ".concat(swiper.realIndex + 1, " of ").concat(swiper.pagination.bullets.length);
                            }
                        },
                    },
                });
            },
            openFlyout: function (id, url) {
                return __awaiter(this, void 0, void 0, function () {
                    var cached, res, data, _a;
                    var _this = this;
                    var _b, _c, _d, _e, _f, _g;
                    return __generator(this, function (_h) {
                        switch (_h.label) {
                            case 0:
                                this.previouslyFocused = document.activeElement;
                                this.flyoutOpen = true;
                                this.flyoutError = false;
                                this.flyoutUrl = url;
                                this.lockScroll(true);
                                // Move focus into the panel once it's on screen.
                                this.$nextTick(function () {
                                    var _a;
                                    (_a = _this.$refs.closeButton) === null || _a === void 0 ? void 0 : _a.focus();
                                });
                                cached = this.cache[id];
                                if (cached) {
                                    this.flyoutTitle = cached.title;
                                    this.flyoutHeader = cached.header;
                                    this.flyoutContent = cached.content;
                                    this.flyoutUrl = cached.url;
                                    this.flyoutLoading = false;
                                    return [2 /*return*/];
                                }
                                this.flyoutLoading = true;
                                this.flyoutTitle = '';
                                this.flyoutHeader = '';
                                this.flyoutContent = '';
                                _h.label = 1;
                            case 1:
                                _h.trys.push([1, 4, 5, 6]);
                                return [4 /*yield*/, fetch("/wp-json/rest/v1/news-flyout/".concat(id), {
                                        headers: { Accept: 'application/json' },
                                        credentials: 'same-origin',
                                    })];
                            case 2:
                                res = _h.sent();
                                if (!res.ok)
                                    throw new Error("Request failed: ".concat(res.status));
                                return [4 /*yield*/, res.json()];
                            case 3:
                                data = (_h.sent());
                                this.flyoutTitle = (_b = data.title) !== null && _b !== void 0 ? _b : '';
                                this.flyoutHeader = (_c = data.header) !== null && _c !== void 0 ? _c : '';
                                this.flyoutContent = (_d = data.content) !== null && _d !== void 0 ? _d : '';
                                this.flyoutUrl = data.link || url;
                                this.cache[id] = {
                                    title: this.flyoutTitle,
                                    header: this.flyoutHeader,
                                    content: this.flyoutContent,
                                    url: this.flyoutUrl,
                                };
                                return [3 /*break*/, 6];
                            case 4:
                                _a = _h.sent();
                                this.flyoutError = true;
                                return [3 /*break*/, 6];
                            case 5:
                                this.flyoutLoading = false;
                                return [7 /*endfinally*/];
                            case 6:
                                (_g = (_f = (_e = this.$store) === null || _e === void 0 ? void 0 : _e.app) === null || _f === void 0 ? void 0 : _f.track) === null || _g === void 0 ? void 0 : _g.call(_f, {
                                    event: 'news_carousel_flyout_open',
                                    type: 'click',
                                    module: 'news-carousel',
                                    data: { articleId: id },
                                });
                                return [2 /*return*/];
                        }
                    });
                });
            },
            closeFlyout: function () {
                this.flyoutOpen = false;
                this.lockScroll(false);
                if (this.previouslyFocused) {
                    this.previouslyFocused.focus();
                }
            },
            lockScroll: function (lock) {
                // Lock the page scroll without repositioning the body, so the flyout's
                // own scroll container keeps working.
                document.documentElement.style.overflow = lock ? 'hidden' : '';
            },
            trapFocus: function (event) {
                var panel = this.$refs.panel;
                if (!panel)
                    return;
                var focusableElements = panel.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                if (focusableElements.length === 0)
                    return;
                var firstEl = focusableElements[0];
                var lastEl = focusableElements[focusableElements.length - 1];
                if (event.shiftKey && document.activeElement === firstEl) {
                    event.preventDefault();
                    lastEl.focus();
                }
                else if (!event.shiftKey && document.activeElement === lastEl) {
                    event.preventDefault();
                    firstEl.focus();
                }
            },
        };
    });
});
